export const getCurrentUserProfile = state => state.entities.profile;
export const getCurrentUserSignature = state => state.entities.signature;
export const getCurrentUserEmailAddresses = state => state.entities.emailAddresses;
export const getCurrentUserAttributes = state => state.entities.attributes;
export const getProfileOptions = state => state.entities.profileOptions;
export const getAlerts = state => state.alerts;
export const getNotifications = state => state.entities.notifications;
export const getAvatar = state => state.entities.avatar;
export const getCurrentPortalSettings = state => state.entities.portalSettings;